import { render, staticRenderFns } from "./SearchBox02.vue?vue&type=template&id=3f3fa603&scoped=true"
import script from "./SearchBox02.vue?vue&type=script&lang=js"
export * from "./SearchBox02.vue?vue&type=script&lang=js"
import style0 from "./SearchBox02.vue?vue&type=style&index=0&id=3f3fa603&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3fa603",
  null
  
)

export default component.exports